import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import addStudente from '../../services/addStudente';
import addUtente from '../../services/addUtente';

import getCorsi from '../../services/getCorsi';
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import Utils from "../../utils/utils";
import addAnagraficaFatture from "../../services/addAnagraficaFatture";
import getClient from "../../services/getClient";

export default class AddStudente extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.selectRef = React.createRef();
    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      nome: '',
      cognome: '',
      mail: '',
      mail2Tipo: '',
      mail2: '',
      indirizzo: '',
      citta: '',
      codiceFiscale: '',
      telefono: '',
      telefono2Tipo: '',
      telefono2: '',
      corsi: []
    }

    this.grid = 2;

    this.pageTitle = "Aggiungi studente";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
        
    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    this.dbPath = cookies.get('db_path', { path: '/' });

    Utils.setAnalyticsPage('Student creation - ' + cookies.get('db', { path: '/' }));

    this.corsi = await getCorsi(username, token);
    this.corsiArray = [];

    this.corsi.map(r => {
      this.corsiArray.push({value: r.id, label: r.name});
  });

    this.setState({ corsiArray: this.corsiArray });
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <div >
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={this.pageTitle} />
          <TextInput name={'Nome'} value={this.state.nome} 
            onChange={(text) => { this.setState({nome: text})}
          } />
          <TextInput name={'Cognome'} value={this.state.cognome} 
            onChange={(text) => { this.setState({cognome: text})}
          } />

          <div key={Math.random()}>
            <SelectInput 
              ref={this.selectRef}
              value={this.state.corsi} 
              name="Corsi" 
              hidable={false}
              options={this.state.corsiArray} 
              isMulti={true}
              onChange={(option) => 
                this.setState({corsi: option})
              }
            />
          </div>

          <div key={Math.random()}>
            <SelectInput 
                ref={this.selectRef}
                value={this.state.corsi} 
                name="Corsi" 
                hidable={false}
                options={this.state.corsiArray} 
                isMulti={true}
                onChange={(option) => 
                    this.setState({corsi: option})} 
                />
          </div>

          <TextInput name={'Mail'} value={this.state.mail} 
            onChange={(text) => { this.setState({mail: text})}
          } /
          >
          <TextInput name={'Mail 2'} value={this.state.mail2} 
            onChange={(text) => { this.setState({mail2: text})}
          } /
          >            
          <TextInput name={'Mail 2 note'} value={this.state.mail2Tipo} 
            onChange={(text) => { this.setState({mail2Tipo: text})}
          } /
          >
          <TextInput name={'Indirizzo'} value={this.state.indirizzo} 
            onChange={(text) => { this.setState({indirizzo: text})}
          } /
          >
          <TextInput name={'Città'} value={this.state.citta} 
            onChange={(text) => { this.setState({citta: text})}
          } /
          >
          <TextInput name={'Codice fiscale'} value={this.state.codiceFiscale} 
            onChange={(text) => { this.setState({codiceFiscale: text})}
          } /
          >
          <TextInput name={'Telefono'} value={this.state.telefono} 
            onChange={(text) => { this.setState({telefono: text})}
          } /
          >
          <TextInput name={'Telefono 2'} value={this.state.telefono2} 
            onChange={(text) => { this.setState({telefono2: text})}
          } /
          >
          <TextInput name={'Telefono 2 note'} value={this.state.telefono2Tipo} 
            onChange={(text) => { this.setState({telefono2Tipo: text})}
          } /
          >



          <FixButton title={'Salva'} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </div>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      var strCorsi = "";
      this.state.corsi && this.state.corsi.forEach(c => {
        strCorsi += c.value + ";";
      });


      let ret = await addStudente (username, token, this.state.cognome, this.state.nome, strCorsi, this.state.mail, this.state.mail2Tipo, this.state.mail2, 
        this.state.indirizzo, this.state.citta, this.state.codiceFiscale, this.state.telefono, this.state.telefono2Tipo, this.state.telefono2);

      var newUsername = await Utils.generateUsername(username, token, this.state.nome, this.state.cognome);
      var password = Utils.generatePassword();

      var asd = await addUtente(username, token, '', '', newUsername, password, 1, ret.id);
      
      let cliente = await getClient('', '', cookies.get('db', { path: '/' }));
      if (cliente.fatturazione_attiva === '1') {
        let res = await addAnagraficaFatture(username, token, ret.id, 'clienti', this.state.nome + ' ' + this.state.cognome, this.state.indirizzo, this.state.citta, this.state.mail, this.state.telefono, this.state.codiceFiscale, '');
        
        if (asd.result == 'ok'){
          // window.location.href =  '/' + this.dbPath + '/#/app/studenti';
         }
         else {
           Utils.showError('An error occurred while creating a new event.')
         }
      } {
        if (asd.result == 'ok'){
          // window.location.href =  '/' + this.dbPath + '/#/app/studenti';
         }
         else {
           Utils.showError('An error occurred while creating a new student.')
         }
      }
        
      if (asd.result == 'ok'){
       // window.location.href =  '/' + this.dbPath + '/#/app/studenti';
      }
      else {
        Utils.showError('An error occurred while creating a new event.')
      }
      
  }

}

